<template>
  <div class="content">
    <img alt="" class="logo" src="../../assets/photo/logo5.png">
    <div class="wz">
      <p>此板块仅供内网使用，</p>
      <p>不用担心您的建议会被其他人看见，</p>
      <p>点击“发送”按钮，</p>
      <p>你的声音将直达留言查看区，</p>
      <p>目前留言查看区仅限总经理一人查看，</p>
      <p>请开始你的畅所欲言吧！</p>
    </div>
    <Form ref="searchForm" :label-width="90" class="from">
      <el-input
        v-model="textarea1"
        :rows="10"
        style="margin-bottom: 10px;"
        type="textarea">
      </el-input>
      <el-upload
        :action="upAction"
        :before-upload="beforeAvatarUpload"
        :file-list="fileList"
        :format="['jpg','jpeg','png']"
        :on-change="handleChange"
        :on-preview="handlePictureCardPreview"
        list-type="picture-card"
      >
        <i class="el-icon-plus"></i>
      </el-upload>
      <Button class="button" @click="add">发送</Button>
    </Form>
    <div v-show="showMask" class="mask" @click="hideMask">
      <img alt="" class="tips" src="../../assets/photo/tips.png">
    </div>
  </div>
</template>
<script>
import {messageAdd, messagePage} from '@/api/roast'

export default {
  name: "company",
  data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      dialogVisibleImg: false,
      fileList: [],
      textarea1: '',
      current: 1,
      upAction: this.$getImg + 'api/auth/img',
      listData: [],
      showMask: false
    }
  },
  components: {},
  mounted() {
    this.handleSearch()
    document.title = "一个树洞";
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG = (file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png')
      if (!isJPG) {
        this.$message.error('只能上传jpg,jpeg,png格式图片!');
      }
      return isJPG
    },
    handleSearch() {
      messagePage({
        current: 1,
        size: 5
      }).then((res) => {
        this.listData = res.data.data.records
      });
    },
    handleChange(file, fileList) {
      this.fileList = fileList
    },
    hideMask() {
      this.showMask = false
      location.reload()
    },
    add() {
      if (!this.textarea1) {
        this.$message.error('请先输入内容')
        return
      }
      let params = {
        messageContent: this.textarea1
      }
      let a = []
      this.fileList.forEach((e) => {
        a.push(this.$getImgUrl + e.response.data)
      })
      params.messageUrl = a.join(',')
      messageAdd(params).then(res => {
        if (res.data.success) {
          this.showMask = true
        } else {
          this.$message.error(res.data.msg)
        }
      }).catch(error => {
        this.addloading = false
        this.$message.error(error.response.data.msg);
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisibleImg = true;
    },
    roastAdd() {
      this.dialogVisible = true
    }
  }
}
</script>
<style>
.wz {
  color: #93a4c6;
  position: absolute;
  top: 350px;
  left: 100px;
  z-index: 2;
  font-size: 20px;
  font-weight: 600;
}

.button {
  margin-left: 800px;
  margin-top: 10px;
  background-color: #93a4c6;
  width: 100px;
  color: #fff;
}

.from {
  width: 1000px;
  background-color: #fff;
  margin-top: 200px;
  border-radius: 5px;
  padding: 20px;
  font-size: 16px;
  margin-left: 200px;
}

.content {
  background-color: #f1f1f1;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow-y: auto;
  padding-top: 10px;
  background-image: url(../../assets/photo/bg.png);
  background-size: cover;
  background-position: center;
}

.logo {
  position: absolute;
  top: 80px;
  left: 100px;
  z-index: 2;
}

.card {
  width: 640px;
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 5px;
  padding: 10px;
  font-size: 16px;
}

.mask {
  background-color: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}

.tips {
  position: absolute;
  top: 30%;
  left: calc(100vh - 225px);
  z-index: 9999;
}
</style>
